import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Discussion from 'flarum/common/models/Discussion';
import User from 'flarum/common/models/User';
import Badge from 'flarum/common/components/Badge';
export default function addFollowBadge() {
  extend(Discussion.prototype, 'badges', function (items) {
    const user = this.user();
    if (user && user instanceof User) {
      var _user$followed;
      const followedStatus = (_user$followed = user.followed) == null ? void 0 : _user$followed.call(user);
      if (followedStatus) {
        items.add('user-following', m(Badge, {
          label: app.translator.trans("ianm-follow-users.forum.badge.label.".concat(followedStatus)),
          icon: "fas fa-user-friends",
          type: "friend"
        }));
      }
    }
  });
  extend(User.prototype, 'badges', function (items) {
    var _this$followed;
    const followedStatus = (_this$followed = this.followed) == null ? void 0 : _this$followed.call(this);
    if (followedStatus) {
      items.add('user-following', m(Badge, {
        label: app.translator.trans("ianm-follow-users.forum.badge.label.".concat(followedStatus)),
        icon: "fas fa-user-friends",
        type: "friend"
      }));
    }
  });
}